/* ==========================================================================
   Full Cart — Global animation runtime

   Reveals any element carrying `.fc-animate` once it enters the viewport by
   adding `.fc-animate--in`. Works with elements injected later (theme editor,
   marquee clones) via a MutationObserver.

   Usage: <div class="fc-animate" data-fc-animate="fade-up" data-fc-animate-delay="200">

   Developer: Jon
   Updated:   2026-08-19
   ========================================================================== */

(function () {
  'use strict';

  var SELECTOR = '.fc-animate';
  var IN_CLASS = 'fc-animate--in';
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(el) {
    var delay = parseInt(el.getAttribute('data-fc-animate-delay'), 10);
    if (!isNaN(delay) && delay > 0) {
      el.style.setProperty('--fc-anim-delay', delay + 'ms');
    }
    el.classList.add(IN_CLASS);
  }

  // No IntersectionObserver or the visitor prefers reduced motion:
  // show everything immediately rather than leaving content invisible.
  if (reduceMotion || !('IntersectionObserver' in window)) {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      el.classList.add(IN_CLASS);
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  function observe(root) {
    var scope = root || document;
    if (scope.nodeType === 1 && scope.matches && scope.matches(SELECTOR)) {
      observer.observe(scope);
    }
    if (!scope.querySelectorAll) return;
    scope.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.classList.contains(IN_CLASS)) return;
      observer.observe(el);
    });
  }

  observe(document);

  // Catch elements added by the theme editor or by section scripts.
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) observe(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });
})();
